import { WidthWrapper } from 'components'
import TabsList from 'components/TabsList'
import { OwnedTopicsTab } from 'modules/territory'

import type { TListGlobalTopicsPageView } from './list-global-topics-page.types'
import { GlobalTopicFavoriteList } from '../global-topic-favorite-list'
import { GlobalTopicListTab } from '../global-topic-list-tab'
import { ThemeListTab } from '../theme-list-tab'
import './list-global-topics-page.styles.scss'

export const ListGlobalTopicsPageView = ({ tabs, currentTab, isGlobalTaxonomyEnabled }: TListGlobalTopicsPageView) => {
  return (
    <WidthWrapper>
      <div className="ListGlobalTopicsPage">
        <TabsList tabs={tabs} />
        <div>
          {currentTab === 'owned' && <OwnedTopicsTab />}
          {currentTab === 'territories' && (isGlobalTaxonomyEnabled ? <ThemeListTab /> : <GlobalTopicListTab />)}
          {currentTab === 'favorites' && <GlobalTopicFavoriteList />}
        </div>
      </div>
    </WidthWrapper>
  )
}
